"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _useCountdown = require("./use-countdown");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Countdown = function Countdown(props) {
  var timeLeft = (0, _useCountdown.useCountdown)(props);

  if (!props.children) {
    return null;
  }

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, props.children({
    timeLeft: timeLeft
  }));
};

Countdown.propTypes = {
  children: _propTypes.default.func
};
var _default = Countdown;
exports.default = _default;